module.exports = __webpack_public_path__ + "img/discharging.45fbe898.gif";